module.exports = __webpack_public_path__ + "img/violence1.5536b4cc.png";